module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_gmail-b2b3e0b35ccdc6db87cfa82aba74ac82.png";